import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

import { getGridItemWidth } from '@/utils/gridItemWidth';

export const styles = StyleSheet.create((colors, rt) => ({
  container: {
    flex: 1,
    paddingHorizontal: theme.spacing[5],
    paddingTop: theme.spacing[5],
  },
  servicesGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing[4],
    paddingBottom: rt.insets.bottom + theme.spacing[4],
  },
  gridItem: (numColumns: number) => {
    const itemAspectRatio = 4 / 3;
    const width = getGridItemWidth({
      screenWidth: Math.min(theme.breakpoints.tablet, rt.screen.width),
      horizontalPadding: theme.spacing[5] * 2,
      gap: theme.spacing[4],
      numColumns,
    });

    return {
      width: width,
      minHeight: (width * itemAspectRatio) / 2,
      aspectRatio: itemAspectRatio,
    };
  },
  card: {
    flex: 1,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    borderRadius: theme.borderRadius.l,
  },
  priceSkeleton: {
    position: 'absolute',
    bottom: theme.spacing[4],
    right: 0,
    height: 26,
    width: '25%',
    borderRadius: 0,
    borderTopLeftRadius: theme.borderRadius.xs,
    borderBottomLeftRadius: theme.borderRadius.xs,
    backgroundColor: colors.backgroundL1,
  },
}));
